export const EVENT_SOURCE = 'petsdeli';

export const GTM_READY_TIMEOUT_MS = 5000;

// DataLayer inherits properties from previous events.
// Our biggest concern is `eventSource`, which is set to `petsdeli` for our events.
// When third-parties push anything to dataLayer it will inherit that source.
export const CLEANUP_EVENT = {
  eventData: undefined,
  eventName: undefined,
  eventGroup: undefined,
  eventSource: undefined,
};
